import { render, staticRenderFns } from "./CellInfo.vue?vue&type=template&id=24665224&scoped=true&"
import script from "./CellInfo.vue?vue&type=script&lang=js&"
export * from "./CellInfo.vue?vue&type=script&lang=js&"
import style0 from "./CellInfo.vue?vue&type=style&index=0&id=24665224&prod&scoped=true&lang=scss&"
import style1 from "./CellInfo.vue?vue&type=style&index=1&id=24665224&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24665224",
  null
  
)

export default component.exports